/**
 * @since 2.0.0
 */

/** @internal */
export const getBugErrorMessage = (message: string) =>
  `BUG: ${message} - please report an issue at https://github.com/Effect-TS/effect/issues`
